import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthorized-site',
  templateUrl: './unauthorized-site.component.html',
  styleUrls: ['./unauthorized-site.component.scss']
})
export class UnauthorizedSiteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
